/** Enter отправляет, Shift+Enter переносит строку, набор IME не трогаем. */
export function shouldSubmitOnKey(event: {
  key: string;
  shiftKey: boolean;
  isComposing?: boolean;
}): boolean {
  return event.key === "Enter" && !event.shiftKey && !event.isComposing;
}
